import React from "react";

const LegendCircle = ({colour, size = 12}: { colour: string, size?: number | string }) => {
  return (
    <span
      style={{
        display: "inline-block",
        width: size,
        height: size,
        borderRadius: "50%",
        backgroundColor: colour,
        marginRight: "0.5rem",
      }}
    />
  );
};
export default LegendCircle;